<template>
    <div :class="['privilege-list']">
        <div
            v-if="(vipInfo.vipStatusName !== 'beginnerVip'
                && vipInfo.vipStatusName !== 'freeVip'
                && vipInfo.vipStatusName !== 'eliteVip') && noHasPrivilegeList.length"
            class="nohas-privilege privilege-part"
        >
            <div class="title">
                未获取权益 · 待解锁
            </div>
            <div class="privilege">
                <privilege-card
                    v-for="item in noHasPrivilegeList"
                    :key="item.id"
                    class="card"
                    :privilege-info="item"
                    :is-no-has="true"
                />
            </div>
        </div>
        <div
            v-if="hasPrivilegeList.length"
            class="has-privilege privilege-part"
        >
            <div class="title">
                {{
                    vipInfo.vipStatusName === "vip" ? "我的权益" : "已获取权益"
                }}
            </div>
            <div class="privilege">
                <privilege-card
                    v-for="item in hasPrivilegeList"
                    :key="item.id"
                    class="card"
                    :privilege-info="item"
                />
            </div>
        </div>
        <div
            v-if="(vipInfo.vipStatusName === 'beginnerVip'
                || vipInfo.vipStatusName === 'freeVip'
                || vipInfo.vipStatusName === 'eliteVip') && noHasPrivilegeList.length"
            class="nohas-privilege privilege-part"
        >
            <div class="title">
                未获取权益 · 待解锁
            </div>
            <div class="privilege">
                <privilege-card
                    v-for="item in noHasPrivilegeList"
                    :key="item.id"
                    class="card"
                    :privilege-info="item"
                    :is-no-has="true"
                />
            </div>
        </div>
    </div>
</template>
<script>
/**
 * @desc 权益列表
 * @author <xingminghua@baidu.com>
 */
import PrivilegeCard from './privilege-card.vue';

export default {
    components: {
        'privilege-card': PrivilegeCard
    },
    props: {
        vipInfo: {
            type: Object,
            default: () => {
                return {};
            }
        },
        privilegeList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            hasPrivilegeList: [],
            noHasPrivilegeList: []
        };
    },
    watch: {
        privilegeList: {
            handler(newVal) {
                this.formatPrivilegeList(newVal);
            },
            immediate: true
        }
    },
    methods: {
        formatPrivilegeList(list) {
            const privilegeList = list || [];
            const hasPrivilegeList = privilegeList.filter(item => !item.disable);
            const noHasPrivilegeList = privilegeList.filter(
                item => item.disable
            );
            this.hasPrivilegeList = hasPrivilegeList;
            this.noHasPrivilegeList = noHasPrivilegeList;
        }
    }
};
</script>
<style lang="less" scoped>
.privilege-part {
    margin-top: 30px;

    .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #000;
        line-height: 18px;
        font-weight: 600;
        position: relative;

        .bubble {
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #fff;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            background: #fd503e;
            border-radius: 27px 27px 27px 0;
            padding: 2px 5px;
            transform: scale(.9);
            transform-origin: 0 0;
            display: inline-block;
            position: absolute;
            left: 84px;
            top: -6px;
        }
    }

    .privilege {
        margin-top: 16px;
        padding-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        margin-right: -14px;

        .card {
            margin-right: 14px;
            margin-top: 14px;
        }

        /deep/ .privilege-card {
            width: calc(((100% - 70px) / 5));
        }
    }
}
</style>
